import { Injectable } from '@angular/core';
import { EventCartItem } from '../models/cart.model';
import { EventDateDao } from '../db-models/event-date-dao';

@Injectable({
  providedIn: 'root',
})
export class EventsHelperService {
  displayRegularData(event: EventDateDao): boolean {
    return (event.regular_booking_count < event.regular_capacity);
  }

  displayWaitingData(event: EventDateDao): boolean {
    return (event.waitinglist_booking_count < event.waitinglist_capacity);
  }

  isSlotBooked(slotId: number, bookedSlots: EventCartItem[]): boolean {
    const bookedItem = bookedSlots.find(slot => slot.slotId === slotId);
    return !!bookedItem;
  }

  isSlotAvailable(slotInfo: EventDateDao, bookedItems: EventCartItem[]): boolean {
    let isAnyBookableSlot = false;
    const isDisplayable = this.displayRegularData(slotInfo) || this.displayWaitingData(slotInfo);
    const isBooked = this.isSlotBooked(slotInfo.id, bookedItems);

    if (isDisplayable && !isBooked) {
      isAnyBookableSlot = true;
    }

    return isAnyBookableSlot;
  }
}
